import React from 'react';

const NoServices = () => (
  <div className="layout__item u-1/2-medium-and-up u-1/3-extralarge-and-up u-mb0">
    There are no services for selected professional
  </div>
);

export default NoServices;



// WEBPACK FOOTER //
// ./src/app/services/components/NoServices.jsx